/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, May 19th 2022, 6:54:48 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { PlainDialog, OSCircularProgress } from "ui-widgets";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

export const OrganizationLoadingDialog = () => (
  <PlainDialog open={true} title="">
    <div className="os-organization-loading-modal">
      <Stack spacing={8}>
        <div className="os-organization-loading-modal-content">
          <OSCircularProgress />
        </div>
        <div className="os-organization-loading-modal-content">
          <Typography variant="body1">Loading Organization...</Typography>
        </div>
      </Stack>
    </div>
  </PlainDialog>
);
